// eslint-disable-next-line import/prefer-default-export
export const getEmailDomain = (email: string) => {
  const atSymbolIndex = email.indexOf('@');
  return email.slice(atSymbolIndex + 1);
};
